var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center",attrs:{"id":"notification-bar"}},[(_vm.$root.hasSalesPromo)?_c('p',[_c('a',{attrs:{"href":_vm.salesUrl}},[_vm._v("\n      "+_vm._s(_vm.notificationMsg)+"\n    ")])]):_c('p',[_vm._v(_vm._s(_vm.notificationMsg))])])
}
var staticRenderFns = []

export { render, staticRenderFns }